import * as React from 'react';

import EnterpriseDisplayEnrollButton from 'bundles/unified-description-page-common/components/enroll/enterprise/EnterpriseDisplayEnrollButton';
import type { EnrollButtonSize } from 'bundles/unified-description-page-common/components/enroll/enterprise/enterpriseEnrollButtonOverrideStyles';
import ProgramAtCapacityModal from 'bundles/unified-description-page-common/components/shared/modals/ProgramAtCapacityModal';
import useEnterpriseCourseEnrollment from 'bundles/unified-description-page-common/hooks/useEnterpriseCourseEnrollment';

type Props = {
  enrollButtonRef?: React.MutableRefObject<HTMLDivElement | null>;
  shouldShowSponsoredByMessage?: boolean;
  size?: EnrollButtonSize;
  courseId?: string;
  privateSessionStart?: number;
  trackingOnClick?: () => void;
  onActionSuccess: () => void;
};

export const EnterpriseOptimizedEnrollmentButton = ({
  enrollButtonRef,
  size,
  courseId,
  privateSessionStart,
  shouldShowSponsoredByMessage,
  onActionSuccess,
  trackingOnClick,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [enrollIntoCourse, { isEnrolling, programJoinErrorCode, error }] =
    useEnterpriseCourseEnrollment(onActionSuccess);

  React.useEffect(() => {
    if (programJoinErrorCode) {
      setIsModalOpen(true);
    }
  }, [programJoinErrorCode]);

  const onClickEnroll = () => {
    if (trackingOnClick) {
      trackingOnClick();
    }
    enrollIntoCourse();
  };

  const setOpen = (isOpen: boolean) => {
    setIsModalOpen(isOpen);
  };

  return (
    <React.Fragment>
      <EnterpriseDisplayEnrollButton
        courseId={courseId}
        privateSessionStart={privateSessionStart}
        size={size}
        shouldShowSponsoredByMessage={shouldShowSponsoredByMessage}
        onClick={onClickEnroll}
        enrollButtonRef={enrollButtonRef}
        trackingName="current_program_enroll_button"
        dataE2eName="current-program-enroll-button"
        loading={isEnrolling}
        error={error}
      />
      {programJoinErrorCode && (
        <ProgramAtCapacityModal isOpen={isModalOpen} setOpen={setOpen} programJoinErrorCode={programJoinErrorCode} />
      )}
    </React.Fragment>
  );
};

export default EnterpriseOptimizedEnrollmentButton;
